/** A test's place in Build → Activate → Run. The API's five statuses fold into three phases. */
export type TestPhase = 'draft' | 'active' | 'finished';

export type StepState = 'done' | 'current' | 'upcoming';

/** i18n keys for the three lifecycle steps, in order. */
export const LIFECYCLE_STEP_KEYS = ['lifecycle_build', 'lifecycle_activate', 'lifecycle_run_finish'] as const;

/** Published tests are running; archived ones are over. */
export function testPhase(status?: string | null): TestPhase {
  const s = (status || 'draft').toLowerCase();
  if (s === 'active' || s === 'published') return 'active';
  if (s === 'finished' || s === 'archived') return 'finished';
  return 'draft';
}

/** A draft stays on Build until every readiness check passes; only then is Activate the current step. */
export function lifecycleSteps(phase: TestPhase, allReady: boolean): [StepState, StepState, StepState] {
  if (phase === 'finished') return ['done', 'done', 'done'];
  if (phase === 'active') return ['done', 'done', 'current'];
  return allReady ? ['done', 'current', 'upcoming'] : ['current', 'upcoming', 'upcoming'];
}

/** Index of the current step; a finished test sits on its last step. */
export function currentStepIndex(steps: StepState[]): number {
  const i = steps.indexOf('current');
  return i === -1 ? steps.length - 1 : i;
}
